(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('.womanella-modern-product').forEach(product => {
      if (product.dataset.wmInitialized) return;
      product.dataset.wmInitialized = 'true';
      const header = document.querySelector('.section-header');
      const measure = () => product.style.setProperty('--wm-header', Math.max(0, Math.round(header?.getBoundingClientRect().height || 0)) + 'px');
      measure();
      const resize = new ResizeObserver(measure);
      if (header) resize.observe(header);
      const syncPrice = () => {
        const price = product.querySelector('[id^="price-"] .price');
        const current = price?.querySelector(price.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
        const target = product.querySelector('.wm-submit-price');
        if (target && current) {
          const value = current.textContent.trim();
          if (target.textContent !== value) target.textContent = value;
          target.hidden = Boolean(price.closest('.hidden'));
        }
      };
      const observer = new MutationObserver(syncPrice);
      observer.observe(product, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class']});
      syncPrice();
      product.addEventListener('keydown', event => {
        if (event.key === 'Escape' && event.target.closest('.wm-product-detail[open]')) {
          const detail = event.target.closest('.wm-product-detail');
          detail.open = false; detail.querySelector('summary').focus();
        }
      });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(product)) { resize.disconnect(); observer.disconnect(); }
      }, {once:true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', () => initialize());
})();